import { useTranslation } from 'react-i18next';

import { getIconForTopicBySourceId } from '@klv/organisms/topics-menu/utils/functions';

import * as s from './styles';

import type { IArticleMeta } from './types';

const ArticleMeta = ({
  date,
  readTime,
  title = '',
  topicSourceId,
}: IArticleMeta) => {
  const { t } = useTranslation();
  const formattedDate = date ? new Date(date).toLocaleDateString(t('langCodes_locale'), 
    { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' }) : '';

  return (
    <s.StyledArticleMeta>
      <s.TopicTitleContainer>
        <s.TopicIcon fillColor="currentColor" iconName={getIconForTopicBySourceId(topicSourceId)} size={3} />
        <s.StyledTitle colorVariant="dark" variant="h4Semibold" forwardedAs="h1">{title}</s.StyledTitle>
      </s.TopicTitleContainer>
      {(readTime || formattedDate) && (
        <s.BodyContainer colorVariant="dark" variant="tagline">
          {readTime && (
            <s.Readtime>
              {`${t('molecules_articleMeta_estimated')} ${readTime} ${t('molecules_articleMeta_minuteRead')}`}
            </s.Readtime>
          )}
          {readTime && formattedDate && <s.StyledDivider>|</s.StyledDivider>}
          {formattedDate && (
            <s.Date>
              {`${t('molecules_articleMeta_updated')} ${formattedDate} EST`}
            </s.Date>
          )}
        </s.BodyContainer>
      )}
    </s.StyledArticleMeta>
  );
};

export default ArticleMeta;
